var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11632_27226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24ZM12 6C11.5875 6 11.25 6.3375 11.25 6.75V12.75C11.25 13.1625 11.5875 13.5 12 13.5C12.4125 13.5 12.75 13.1625 12.75 12.75V6.75C12.75 6.3375 12.4125 6 12 6ZM13.125 16.5C13.125 16.2016 13.0065 15.9155 12.7955 15.7045C12.5845 15.4935 12.2984 15.375 12 15.375C11.7016 15.375 11.4155 15.4935 11.2045 15.7045C10.9935 15.9155 10.875 16.2016 10.875 16.5C10.875 16.7984 10.9935 17.0845 11.2045 17.2955C11.4155 17.5065 11.7016 17.625 12 17.625C12.2984 17.625 12.5845 17.5065 12.7955 17.2955C13.0065 17.0845 13.125 16.7984 13.125 16.5Z",
    fill: "#040404"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11632_27226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.e9ec4ece74033b80b4551bc9dbc8ab09.svg";
export { ForwardRef as ReactComponent };